import WeeklyEmail from './WeeklyEmail'

export default WeeklyEmail
